import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

/* =========================
SCROLL TOP
========================= */

import ScrollToTop from "./Client/Pages/ScrollToTop";

/* =========================
CLIENT IMPORTS
========================= */

import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";

import Home from "./Client/Pages/Home";
import AboutUs from "./Client/Pages/About";
import Membership from "./Client/Pages/Membership";
import Loan from "./Client/Pages/Loan";
import Insurance from "./Client/Pages/Insurance";
import Join from "./Client/Pages/Join";
import Gallery from "./Client/Pages/Gallery";
import Services from "./Client/Pages/Service";

/* =========================
ADMIN IMPORTS
========================= */

import Sidebar from "./gruhlaxmiMyAdmin/Layouts/Sidebar";
import Header from "./gruhlaxmiMyAdmin/Layouts/Header";

import Dashboard from "./gruhlaxmiMyAdmin/Pages/Dashboard";
import Aboutus from "./gruhlaxmiMyAdmin/Pages/Aboutus";
import Contactus from "./gruhlaxmiMyAdmin/Pages/Contactus";
import Contactinfo from "./gruhlaxmiMyAdmin/Pages/Contactinfo";
import Team from "./gruhlaxmiMyAdmin/Pages/Team";
import ServicesAdmin from "./gruhlaxmiMyAdmin/Pages/Services";
import Activities from "./gruhlaxmiMyAdmin/Pages/Activites";
import Holidays from "./gruhlaxmiMyAdmin/Pages/Holiday";
import News from "./gruhlaxmiMyAdmin/Pages/News";
import Logout from "./gruhlaxmiMyAdmin/Pages/Logout";
import Login from "./gruhlaxmiMyAdmin/Pages/Login";
import ForgotPassword from "./gruhlaxmiMyAdmin/Pages/ForgotPassword";
import PrivateRoute from "./gruhlaxmiMyAdmin/Pages/PrivateRoute";

/* =========================
CLIENT CSS
========================= */

import "./Client/Styles/Navbar.css";
import "./Client/Styles/Footer.css";
import "./Client/Styles/Home.css";
import "./Client/Styles/Aboutus.css";
import "./Client/Styles/MemberShip.css";
import "./Client/Styles/Loan.css";
import "./Client/Styles/insourance.css";
import "./Client/Styles/Join.css";
import "./Client/Styles/Gallery.css";
import "./Client/Styles/Services.css";
import "./Client/Styles/themes.css";

/* =========================
ADMIN CSS
========================= */

import "./gruhlaxmiMyAdmin/Styles/themes.css";
import "./gruhlaxmiMyAdmin/Styles/Sidebar.css";
import "./gruhlaxmiMyAdmin/Styles/Header.css";
import "./gruhlaxmiMyAdmin/Styles/Aboutus.css";
import "./gruhlaxmiMyAdmin/Styles/Contactus.css";
import "./gruhlaxmiMyAdmin/Styles/contactinfo.css";
import "./gruhlaxmiMyAdmin/Styles/team.css";
import "./gruhlaxmiMyAdmin/Styles/Services.css";
import "./gruhlaxmiMyAdmin/Styles/Dashboard.css";
import "./gruhlaxmiMyAdmin/Styles/Activities.css";
import "./gruhlaxmiMyAdmin/Styles/Logout.css";
import "./gruhlaxmiMyAdmin/Styles/Login.css";
import "./gruhlaxmiMyAdmin/Styles/Holiday.css";
import "./gruhlaxmiMyAdmin/Styles/news.css";
import "./gruhlaxmiMyAdmin/Styles/forgotPassword.css";

/* =========================
LAYOUT COMPONENT
========================= */

function Layout() {
  const location = useLocation();

  // Check admin routes
  const isAdminRoute = location.pathname.startsWith("/gruhlaxmiMyAdmin");

  // Hide sidebar/header/content on login pages
  const hideAdminLayout =
    location.pathname === "/gruhlaxmiMyAdmin/login" ||
    location.pathname === "/gruhlaxmiMyAdmin/forgot-password";

  return (
    <div>
      <ScrollToTop />

      {/* =========================
CLIENT NAVBAR
========================= */}

      {!isAdminRoute && <Navbar />}

      {/* =========================
ADMIN LAYOUT
========================= */}

      <div className={isAdminRoute ? "admin-layout" : "client-layout"}>
        {isAdminRoute && !hideAdminLayout && <Sidebar />}

        <div className={isAdminRoute ? "main" : ""}>
          {isAdminRoute && !hideAdminLayout && <Header />}

          {/* Content Wrapper */}
          <div className={isAdminRoute && !hideAdminLayout ? "content" : ""}>
            <Routes>
              {/* =========================
CLIENT ROUTES
========================= */}

              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/loans" element={<Loan />} />
              <Route path="/insurance" element={<Insurance />} />
              <Route path="/join" element={<Join />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/service" element={<Services />} />

              {/* =========================
ADMIN PUBLIC ROUTES
========================= */}

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin"
                element={<Navigate to="/gruhlaxmiMyAdmin/login" />}
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/login"
                element={<Login />}
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/forgot-password"
                element={<ForgotPassword />}
              />

              {/* =========================
ADMIN PROTECTED ROUTES
========================= */}

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/about"
                element={
                  <PrivateRoute>
                    <Aboutus />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/contactus"
                element={
                  <PrivateRoute>
                    <Contactus />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/contactinfo"
                element={
                  <PrivateRoute>
                    <Contactinfo />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/team"
                element={
                  <PrivateRoute>
                    <Team />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/services"
                element={
                  <PrivateRoute>
                    <ServicesAdmin />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/activities"
                element={
                  <PrivateRoute>
                    <Activities />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/holiday"
                element={
                  <PrivateRoute>
                    <Holidays />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/news"
                element={
                  <PrivateRoute>
                    <News />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/gruhlaxmiMyAdmin/logout"
                element={
                  <PrivateRoute>
                    <Logout />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </div>
      </div>

      {/* =========================
CLIENT FOOTER
========================= */}

      {!isAdminRoute && <Footer />}
    </div>
  );
}

/* =========================
APP MAIN
========================= */

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
